import React from "react";
import MaterialTable from "material-table";
import { withStyles, Paper } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

// Components
import CustomMTableHeader from "../../../../../../Component/Table/CustomMTableHeader";
import CustomMTableRow from "../../../../../../Component/Table/CustomTableRow";
import CustomMTableCell from "../../../../../../Component/Table/CustomMTableCell";
import {
  tableIcons,
  tableStyle,
  tableOptions,
} from "../../../../../../Component/Table/tableCommonStyles";

// Other
import { TableHeader } from "./tableHeader";
import { styles } from "./styles";
import { useTranslation } from "react-i18next";

const CountryExchangesTable = (props) => {
  const {
    classes,
    exchanges,
    loading,
    onNewAction,
    onUpdateRecord,
    canAdd,
    canEdit,
  } = props;
  const { t } = useTranslation();

  const onRowUpdate = async (exchange) => {
    return new Promise(async (resolve, reject) => {
      const result = await onUpdateRecord(exchange);
      result ? resolve() : reject();
    });
  };

  return (
    <div className={classes.tableWrapper}>
      <MaterialTable
        editable={
          canEdit && {
            isEditable: () => true,
            onRowUpdate: onRowUpdate,
          }
        }
        title=""
        style={tableStyle}
        icons={tableIcons}
        elevation="0"
        options={{
          ...tableOptions,
          toolbar: true,
          search: true,
        }}
        actions={[
          canAdd && {
            icon: () => <AddIcon />,
            tooltip: t(
              "labels.country.exchangeList.exchangeTable.actions.addExchange",
            ),
            onClick: onNewAction,
            isFreeAction: true,
          },
        ]}
        data={exchanges}
        localization={{
          header: {
            actions: t("labels.common.table.actions"),
          },
          toolbar: {
            searchPlaceholder: t("labels.common.search"),
          },
          body: {
            emptyDataSourceMessage: t("labels.common.table.noRecordsFound"),
            editTooltip: t("labels.common.edit"),
            editRow: {
              saveTooltip: t("labels.common.save"),
              cancelTooltip: t("labels.common.cancel"),
            },
          },
        }}
        columns={TableHeader(t)}
        isLoading={loading}
        components={{
          Container: (props) => <Paper {...props} elevation={0} />,
          Header: (props) => <CustomMTableHeader {...props} />,
          Row: (props) => <CustomMTableRow {...props} />,
          Cell: (props) => <CustomMTableCell {...props} />,
        }}
      />
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(CountryExchangesTable);
